import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { BASE_URL } from "../config";
import authStorage from "../utils/authStorage";

const FetchDeviceData = ({ back }) => {
    const [devices, setDevices] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState("1");
    const [selectedUser, setSelectedUser] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [error, setError] = useState('');
    const [msg,setMsg]=useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
 useEffect(() => {
    let isAdmin = ["admin"].includes(authStorage.getItem("roles"));
    
    // If roles is not admin, redirect to dashboard page
    if (!isAdmin) {
      window.location = window.location.origin + "/membership";
      return false;
    }
  });
    const getUsersList = (event) => {
        setLoading(true);
        axios({
          headers: {
            "x-access-token": authStorage.getItem("auth-token"),
          },
          url: `${BASE_URL}/user/list`, 
          method: "GET",
        })
          .then((res) => {
            setUsers(res?.data?.data?.data);
          })
          .catch((err) => {
            setLoading(false);
          });
      };
    
      useEffect(() => {
        getUsersList();
      }, []);
      const backFunction =async ()=>{
        navigate("/dashboard");
        back(2);
      }
      const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("handle submit button call", selectedDevice, selectedUser, fromDate, toDate)
    
        if (!selectedDevice || !selectedUser  || !fromDate || !toDate) {
            setError("All fields are required.");
            setTimeout(() => setError(''), 5000);
            return;
        }
    
        let apiURl;
        if (selectedDevice === "1") {
            console.log("fitbit select 57")
            apiURl = `${BASE_URL}/fitbit/restore-fitbit-heart-rate/${selectedUser}/${fromDate}/${toDate}`;
        } else if (selectedDevice === "2") {
            apiURl = `${BASE_URL}/garmin/restore-garmin-heart-rate/${selectedUser}/${fromDate}/${toDate}`;
        } else {
            setError("Invalid device selected.");
            setTimeout(() => setError(''), 5000);
            return;
        }
    
        console.log("apiURl:", apiURl);
    
        try {
            const response = await axios.get(apiURl);
            console.log("Data Fetched Successfully", response.data);
            setLoading(false);
            if(response.data){

                setMsg(`Data Fetched Successfully ${response.data}`);
            }
            setTimeout(()=>{
                navigate("/dashboard")
                back(2);
            },2000)
            
            
        } catch (error) {
            console.error("Error fetching data", error);
            setError("Failed to fetch data");
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-200 h-screen p-10">
            <div className="m-auto rounded-lg p-8 bg-white shadow-lg">
                <div className="text-black text-xl px-4">Fetch Device Data</div>
                <form style={{ zIndex: '80000' }}  action="#" method="POST">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700">Select Device</label>
                            <select value={selectedDevice} onChange={(e) => setSelectedDevice(e.target.value)} className="w-full p-2 border rounded">
                                <option value="">-- Select Device --</option>
                                <option value="1">FitBit</option>
                                <option value="2">Garmin</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-gray-700">Select User</label>
                            <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
                                <option value="">-- Select User --</option>
                                {users.map(user => <option key={user._id} value={selectedDevice=="1"?user.fitBitId:user.garminId}>{user.firstName} {user.lastName}</option>)}
                                {/* {users.map(user => <option key={user._id} value={{"fitBitId":user.fitBitId,"garminId":user.garminId}}>{user.firstName} {user.lastName}</option>)} */}
                            </select>
                        </div>
                        <div>
                            <label className="block text-gray-700">From Date</label>
                            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="w-full p-2 border rounded" />
                        </div>
                        <div>
                            <label className="block text-gray-700">To Date</label>
                            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="w-full p-2 border rounded" />
                        </div>
                    </div>
                    {error && <div className="text-red-500 mt-2">{error}</div>}
                    <div className="mt-6 flex justify-end" >
                    <button onClick={ handleSubmit} type="button" className="button-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
                        Fetch Request
                    </button>
                    <button onClick={backFunction} type="button" className="button-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
                      Go to Dashboard 
                    </button>
                    </div>
                </form>
                {msg && <h2>{msg}</h2>}
            </div>
        </div>
    );
};

export default FetchDeviceData;
